import { Units } from './Inventory';

export type InventoryPlacement = {
  units: Units;
  locationSellingStatus: 'Available' | 'Not available';
  locationStatus: 'Active' | 'Inactive' | 'Other';
  binNo: number;
  storeNo: number;
  typeId: number;
  locationName: string;
  maxShelfCapacity: number;
  minShelfCapacity: number | null;
  skuNo: string;
  descriptionEn: string;
  descriptionFr: string;
  productUrlEn: string;
  productUrlFr: string;
  imageUrlEn: string;
  quantity: number | null;
};

export type InventoryPlacementSearchBy =
  | 'locationSellingStatus'
  | 'locationStatus'
  | 'skuNo';

export const inventoryPlacementSearchByOptions: {
  label: string;
  value: InventoryPlacementSearchBy;
}[] = [
  {
    label: 'SKU Number',
    value: 'skuNo',
  },
  {
    label: 'Location selling status',
    value: 'locationSellingStatus',
  },
  {
    label: 'Location status',
    value: 'locationStatus',
  },
] as const;

export type InventoryPlacementFormValues = {
  binNo: number;
  quantity: number;
  skuNo: string;
};
